import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 90000,
});

export default api;

export const getGithubStatus = () => api.get("/github/status").then((r) => r.data);
export const connectGithub = (token) => api.post("/github/connect", { token }).then((r) => r.data);
export const disconnectGithub = () => api.delete("/github/disconnect").then((r) => r.data);
export const listRepos = () => api.get("/github/repos").then((r) => r.data);

export const listProjects = () => api.get("/projects").then((r) => r.data);
export const createProject = (full_name) => api.post("/projects", { full_name }).then((r) => r.data);
export const getProject = (id) => api.get(`/projects/${id}`).then((r) => r.data);
export const deleteProject = (id) => api.delete(`/projects/${id}`).then((r) => r.data);
export const syncProject = (id) => api.post(`/projects/${id}/sync`).then((r) => r.data);

export const listSessions = (id) => api.get(`/projects/${id}/sessions`).then((r) => r.data);
export const getSession = (id, sid) => api.get(`/projects/${id}/sessions/${sid}`).then((r) => r.data);
export const updateSessionNote = (id, sid, note) =>
  api.patch(`/projects/${id}/sessions/${sid}/note`, { note }).then((r) => r.data);

export const getResume = (id) => api.get(`/projects/${id}/resume`).then((r) => r.data);
export const getTimeline = (id) => api.get(`/projects/${id}/timeline`).then((r) => r.data);
export const getFlow = (id) => api.get(`/projects/${id}/flow`).then((r) => r.data);
export const getFlowNodeFiles = (id, key) =>
  api.get(`/projects/${id}/flow/${encodeURIComponent(key)}/files`).then((r) => r.data);
export const getAiSummary = (id, sid, refresh = false) =>
  api
    .get(`/projects/${id}/sessions/${sid}/ai_summary`, { params: refresh ? { refresh: 1 } : {} })
    .then((r) => r.data);

export const joinWaitlist = (email, repo_full_name) =>
  api.post("/waitlist", { email, repo_full_name }).then((r) => r.data);
export const waitlistCount = () => api.get("/waitlist/count").then((r) => r.data);

export const getReport = (id, kind, refresh = false) =>
  api
    .get(`/projects/${id}/reports/${kind}`, { params: refresh ? { refresh: 1 } : {} })
    .then((r) => r.data);
